const InputRadio = ({ className, label, disabled, id, name, onChange, onClick, checked, inputRef, required, title }) => {
    return (
        <div className={["flex items-center text-gray-600", className].join(" ")}>
            <input
                title={title}
                ref={inputRef}
                id={id}
                name={name}
                type="radio"
                checked={checked}
                disabled={disabled}
                required={required}
                onChange={onChange}
                onClick={onClick}
                className="w-4 h-4 bg-gray-100 border-gray-300 rounded-full"
            />
            <label htmlFor={id} className="ms-2 text-[13px]">
                {label}
            </label>
        </div>
    );
};

export default InputRadio;
